// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__AriQk","icon":"SortAdornment_icon__342gj","up":"SortAdornment_up__EPy2P","down":"SortAdornment_down___be06","active":"SortAdornment_active__16OAN"};